import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box,
} from '@mui/material';

interface SkeletonTableProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
}

export default function SkeletonTable({
  rows = 5,
  columns = 4,
  showHeader = true,
}: SkeletonTableProps) {
  return (
    <TableContainer>
      <Table>
        {showHeader && (
          <TableHead>
            <TableRow>
              {Array.from({ length: columns }).map((_, index) => (
                <TableCell key={`header-${index}`}>
                  <Skeleton variant="text" width="80%" height={24} animation="wave" />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={`row-${rowIndex}`}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={`cell-${rowIndex}-${colIndex}`}>
                  <Skeleton
                    variant="rectangular"
                    width={colIndex === 0 ? 60 : '90%'}
                    height={colIndex === 0 ? 24 : 20}
                    animation="wave"
                    sx={{ borderRadius: colIndex === 0 ? '12px' : '4px' }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

interface SkeletonCardProps {
  count?: number;
}

/**
 * Composant de skeleton pour les cartes
 */
export function SkeletonCard({ count = 1 }: SkeletonCardProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={index}
          sx={{
            p: 3,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
          }}
        >
          <Skeleton variant="text" width="60%" height={32} animation="wave" sx={{ mb: 2 }} />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={100}
            animation="wave"
            sx={{ borderRadius: 1, mb: 1 }}
          />
          <Skeleton variant="text" width="40%" height={20} animation="wave" />
        </Box>
      ))}
    </Box>
  );
}
